// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

// Quick Round tracks hazards by attaching the same hazard "game" definitions the normal
// select-games grid offers under its 'hazard' group (see features/game-definitions/groups.ts) —
// these ids are the canonical config/golf-games ids, not the stale seeder ids elsewhere in that
// file. Duplicated here (a third copy, alongside groups.ts and HoleScreen.tsx's HAZARD_GAME_META)
// rather than shared, since those two files are out of scope for this feature.
export type QuickRoundHazardKey = 'bunker' | 'water' | 'penalty' | 'threePutt' | 'chipIn';

export const QUICK_ROUND_HAZARD_GAME_IDS: Record<QuickRoundHazardKey, string> = {
  water: 'e0b7c8af-3dc8-4a9f-8b77-5d99e5da0a4b',
  bunker: '4d3a1a42-4f67-41a4-b63d-9a9b50a83f1f',
  penalty: '6b9c72e0-6c1c-4d17-9f1f-6c0e2f71a742',
  threePutt: 'f9d88a1b-1a7e-4c86-9b2e-8e7f7f0fcb2b',
  chipIn: '7a2e1c94-3b6d-4f81-9c2a-5d8e0f1a2b3c',
};

export const QUICK_ROUND_DEFAULT_HAZARDS: QuickRoundHazardKey[] = ['bunker', 'water'];

export const QUICK_ROUND_HAZARD_ORDER: QuickRoundHazardKey[] = [
  'bunker',
  'water',
  'penalty',
  'threePutt',
  'chipIn',
];

export function parseQuickRoundHazardsParam(value: string | null | undefined): QuickRoundHazardKey[] {
  if (!value) return [];
  const known = new Set<string>(QUICK_ROUND_HAZARD_ORDER);
  return value
    .split(',')
    .map((part) => part.trim())
    .filter((part): part is QuickRoundHazardKey => known.has(part));
}
